import useLoginInfo from "./useLoginInfo";
import { useEffect } from "react";
import { useSelector } from "react-redux";


const useAccessPinStatus = () => {
    const { userInfo, updateAccessPinStatus } = useLoginInfo();
    const { accessPin } = useSelector((s) => s.entities.wallet);
    
    const getAccessPinStatus = () => {
        if (userInfo.employer?.userType === "employer"){
            return userInfo?.member?.isAccessPinSet;
        }
        else if (userInfo.employer.userType === "employer-admin" || userInfo.employer.userType === "employer-business-member"){
            return userInfo?.member?.isAccessPinSet;
        }
    }
    
    useEffect(() => {
        if (Object.entries(accessPin).length > 0) {
            updateAccessPinStatus();
        }
    }, [accessPin])

    return {
        getAccessPinStatus,
    }
}


export default useAccessPinStatus;
